<template>
  <div class="inline-flex gap-3 justify-between w-full items-center mt-1.5" @click="changeLocation">
    <div class="inline-flex gap-3">
      <div class="flex flex-col cursor-pointer">
        <div class="inline-flex items-center gap-1">
          <div class="flex items-center">
            <svg :class="`w-4 h-4 text-red-700`" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
              height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z"
                clip-rule="evenodd" />
            </svg>
            <h5 class="text-sm font-semibold text-nowrap"
              :class="[runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall' ? 'text-white' : 'dark:text-gray-700']">
              Deliver to</h5>
          </div>
        </div>
        <div class="flex items-center w-full">
          <p
            :class="[`font-semibold line-clamp-2 address-text`, runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall' ? 'text-white' : '']">
            {{ addressText }}</p>
    <img
  v-if="runtimeConfig.public.partnerName === 'HPCL' || runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall'"
  src="/v2/icons/white-chevron-down.png"
  :class="{
    'h-8 w-8': props.textColor === 'white' || runtimeConfig.public.partnerName === 'HPCL' || runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall',
    'h-4 w-4': props.textColor !== 'white',
  }"
  class="ml-1"
  alt="Chevron down icon"
  title="Open location dropdown"
/>
<UIcon
  v-else
  name="i-lucide-chevron-down"
  class="ml-1 h-4 w-4"
/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventCTANames, EventParameter, EventParameterValue } from '~/google_analytics/events.enum';
const runtimeConfig = useRuntimeConfig()

const props = defineProps({
  textColor: { type: String, default: "text-black" },
});

const geolocation = useGeoLocation();
const analyticsEvents = useAnalyticsEvents();
const { addresstext } = useAddressText(location);

const { gtag } = useGtag();
const auth = useAuth();

const isAuthenticated = computed(() => !!auth?.access_token);

// Extract GPS safely
const gps = computed(() => geolocation.selectedAddress?.gps);

// Derived values
const hasLocation = computed(() => !!(gps.value?.latitude && gps.value?.longitude));

const addressText = computed(
  () => geolocation.formatSelectedAddress || "Choose your location"
);

const latitude = computed(() => gps.latitude || 0);
const longitude = computed(() => gps.longitude || 0);

// Single function for opening picker
const openLocation = () => {
  const { openLocationPicker, openLocationUpdate } = useLocationPicker();
  isAuthenticated.value ? openLocationUpdate() : openLocationPicker();
};

const changeLocation = async () => {
  // Analytics (Internal)
  useAnalytics(analyticsEvents.LOCATION_CTA_CLICKED, {
    placement: 'header',
  });

  // Google Analytics
  GoogleAnalytics.locationEvent({
    [EventParameter.ACTION]: EventCTANames.LOCATION_CTA_CLICKED,
    [EventParameter.LATITUDE]: latitude.value,
    [EventParameter.LONGITUDE]: longitude.value,
    [EventParameter.ADDRESS]: addressText.value === 'Choose your location' ? 'none' : addressText.value ? addressText.value : 'none',
    [EventParameter.REASON]: addressText.value === 'Choose your location' ? 'no_delivery_address' : 'address_exit',
    [EventParameter.LOCATION_AVAILABLE]: hasLocation.value ? "yes" : "no",
    [EventParameter.PROMPT_TYPE]: "none",
    [EventParameter.NEEDS_LOCATION_FETCH]: hasLocation.value ? "no" : "yes",
  });
  
  openLocation();
};
</script>

<style scoped>
.address-text {
  max-width: calc(100vw - 140px);
  line-height: 1.25;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
</style>